<template>
  <div >

    <div >
        <p>télécharger le modèle de <a href="/template_supplier.xlsx">fichier excel</a> </p>
        <input type="file" id="file_upload" @change="upload" />
        <!-- table -->
        <div class="table-responsive" v-if="suppliers.length" style="max-height:500px">
            <div style="margin-top:1rem;margin-bottom:1rem"><b>{{suppliers.length}}</b> fournisseurs trouvée.</div>
            <table class="table mb-0 table-borderless table-striped small">

                <thead>
                    <tr class="text-secondary">
                        <th class="pt-4 pb-3 px-6">{{$t('name')}}<span class="required">*</span></th>
                        <th class="pt-4 pb-3 px-6">{{$t('email')}}</th>
                        <th class="pt-4 pb-3 px-6">{{$t('phone')}}</th>
                        <th class="pt-4 pb-3 px-6">{{$t('address')}}</th>
                        <th class="pt-4 pb-3 px-6">{{$t('city')}}</th>
                        <th class="pt-4 pb-3 px-6">{{$t('country')}}</th>
                        <th class="pt-4 pb-3 px-6">{{$t('tax_id')}}</th>
                        <th class="pt-4 pb-3 px-6">{{$t('vat_number')}}</th>
                    </tr>
                </thead>

                <tbody>

                    <tr v-for="(supplier,i) in suppliers" :key="i">
                        <td class="py-5 px-6"><input type="text" :placeholder="$t('name')" v-model="suppliers[i].name"> </td>
                        <td class="py-5 px-6"><input type="text" :placeholder="$t('email')" v-model="suppliers[i].email" ></td>
                        <td class="py-5 px-6"><input type="text" :placeholder="$t('phone')" v-model="suppliers[i].phone"></td>
                        <td class="py-5 px-6"><input type="text" :placeholder="$t('address')" v-model="suppliers[i].address"></td>
                        <td class="py-5 px-6"><input type="text" :placeholder="$t('city')" v-model="suppliers[i].city"></td>
                        <td class="py-5 px-6"><input type="text" :placeholder="$t('country')" v-model="suppliers[i].country"></td>
                        <td class="py-5 px-6"><input type="text" :placeholder="$t('tax_id')" v-model="suppliers[i].tax_id"></td>
                        <td class="py-5 px-6"><input type="text" :placeholder="$t('vat_number')" v-model="suppliers[i].vat_number"></td>
                    </tr>

                </tbody>
            </table>
            <button class="btn btn-success btn-block mt-4" style="width:100%" @click="saveRow" :disabled="loading"><AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />{{$t('save')}}</button>
        </div>
        <!-- table -->
      </div>

  </div>
</template>

<script>
import { read,utils } from "xlsx";
import helper from '../helper'
export default {
  name: 'ImportSupplier',
  data(){
    return {
        suppliers : [],
        loading : false
    }
  },
  methods : {
    upload() {
        var files = document.getElementById('file_upload').files;
        if(files.length==0){
          alert("Please choose any file...");
          return;
        }

        var filename = files[0].name;
        var extension = filename.substring(filename.lastIndexOf(".")).toUpperCase();
        if (extension == '.XLS' || extension == '.XLSX') {
            this.excelFileToJSON(files[0]);
        }else{
            alert("Veuillez sélectionner un fichier Excel valide.");
        }
    },
    excelDateToJSDate(excelDate) {
        return new Date((excelDate - 25569) * 86400 * 1000);
    },
    excelFileToJSON(file){
        try {
            var reader = new FileReader();
            reader.readAsBinaryString(file);
            reader.onload = (e) => {

                var data = e.target.result;
                var workbook = read(data, {
                    type : 'binary'
                });
                workbook.SheetNames.forEach((sheetName) => {
                var roa = utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
                for(let i = 0 ; i < roa.length ; i++){
                    
                    let name = "",
                        email= "",
                        phone = "",
                        address = "",
                        city = "",
                        country = "",
                        tax_id = "",
                        vat_number = "";

                    if(roa[i].name) name = String(roa[i].name).trim()
                    if(roa[i].email) email = String(roa[i].email).trim()
                    if(roa[i].phone) phone = String(roa[i].phone).trim()
                    if(roa[i].address) address = String(roa[i].address).trim()
                    if(roa[i].city) city = String(roa[i].city).trim()
                    if(roa[i].country) country = String(roa[i].country).trim()
                    if(roa[i].tax_id) tax_id = String(roa[i].tax_id).trim()
                    if(roa[i].vat_number) vat_number = String(roa[i].vat_number).trim()

                    this.suppliers.push({
                        name,
                        email,
                        phone,
                        address,
                        city,
                        country,
                        tax_id,
                        vat_number
                    })
                }   

              });

            }
        }catch(e){
          window._errors = e
        }
    },
    async saveRow(){
        try{
           
            this.loading = true;
            await helper.customPost(`${process.env.VUE_APP_API}/suppliers/bulk`,{suppliers: this.suppliers},{showToast:true})
            this.suppliers = []
            this.loading = false;
            this.$emit('upload-success')
            
        }catch(error){
            this.loading = false;
        }

    },
  }
}
</script>

<style scoped>
    .table-borderless>:not(caption)>*>*{
        padding: 5px !important
    }
</style>
